import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { NavigateFunction } from 'react-router-dom';
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { useUiStore } from '@/store/ui';
import { ITYPEProveedorPagingRes, TYPEProveedor } from '@/shared/interfaces/erp/compras/type-proveedor.interface';
import { getUrlParamsFetch, handleAxiosError } from '@/shared';

const { get, post, put } = erpApi();

///* tanSctack query

export const useFetchTypeProveedores = ({
  page = 1,
  nombre = '',
  page_size = 10,
}: GetTypeProveedoresParams) => {
  return useQuery({
    queryKey: ['type-proveedores', page, page_size, nombre],
    queryFn: async () => {
      return getTypeProveedors({ page, nombre, page_size });
    }
  });
};

export const useGetTypeProveedores = (id: string) => {
  return useQuery({
    queryKey: ['type-proveedores', id],
    queryFn: async () => {
      return getTypeProveedor(id);
    },
  });
}
export const useCreateTypeProveedores = (navigate: NavigateFunction, returnUrl: string, enableNavigation?: boolean) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createTypeProveedores,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['type-proveedores'] });
      enableNavigation && navigate(returnUrl, { replace: true });
    },
    onError: error => {
      handleAxiosError(error);
    },
  });
}

export const useUpdateTypeProveedores = (navigate: NavigateFunction, returnUrl: string, noState?: boolean,
  enableNavigation?: boolean) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateTypeProveedores,
    onSuccess: () => {
      noState && queryClient.invalidateQueries({ queryKey: ['type-proveedores'] });
      enableNavigation && navigate(returnUrl, { replace: true });
    },
    onError: error => {
      handleAxiosError(error);
    },
  });
}
//axios
export type GetTypeProveedoresParams = {
  page?: number;
  nombre?: string;
  page_size?: number;
}
export type CreateTypeProveedoresParams = Omit<TYPEProveedor, 'id_grupo_proveedor'>;
export type UpdateTypeProveedoresParams = {
  id: string;
  data: CreateTypeProveedoresParams;
}
export const getTypeProveedors = async (params?: GetTypeProveedoresParams) => {
  const queryParams = getUrlParamsFetch({ ...params });
  return get<ITYPEProveedorPagingRes>(
    `${urlBackend}api/v1/tipos-proveedores/?${queryParams}`,
    true
  );
};
export const getTypeProveedor = async (id: string) => {
  return get<TYPEProveedor>(`${urlBackend}api/tipos-proveedores/${id}/`, true);
}

export const createTypeProveedores = async (data: CreateTypeProveedoresParams) => {
  return post<TYPEProveedor>(`${urlBackend}api/v1/tipos-proveedores/`, data, true);
}
export const updateTypeProveedores = async ({ id, data }: UpdateTypeProveedoresParams) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await put<CreateTypeProveedoresParams>(`${urlBackend}api/v1/tipos-proveedores/${id}/`, data, true);
  setAlert(true, res.message, res.status);
  return res;
}